export default {
  paged: {
    select: 'id,created,number,operationType,status,creator',
    searchSelect: ['number', 'creator'],
  },
  detail: {
    expand: {
      dependsOnTask: { select: 'id,number' },
      user: { select: 'id,fullName' },
    },
  },
};
